import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		contracts: [],
		currencies: [],
		rates: [],
		con_fees: [],
		acc_fees: [],
	},
	mutations: {
		mutate(state, payload) {
			state[payload.property] = payload.with;
		}
		// updateContracts(state, contracts) {
		// 	state.contracts = contracts;
		// },
		// // updatePrevLink(state, links) {
		// // 	state.prevLinks = links;
		// // },
		// // updateLinksState(state, linkState) {
		// // 	state.links = linkState;
		// // },
		// updateCurrencies(state, currencies) {
		// 	state.currencies = currencies;
		// },
		// updateRates(state, rates) {
		// 	state.rates = rates;
		// },
		// updateFees(state, con_fees) {
		// 	state.con_fees = con_fees;
		// },
		// updateAccFees(state, acc_fees) {
		// 	state.acc_fees = acc_fees;
		// }
	},
	actions: {},
});
